import { TYPES } from "../actions";

const initialState = {
  networkModems: [],
  totalCount: 0,
  currentNetworkModem: null,
  loading: false
};

export const tkt1NetworkModemReducer = (state = initialState, action) => {
  switch (action.type) {

    case TYPES.ACTION_GET_TKT1_NETWORK_MODEMS_SUCCESS:
      return { 
        ...state, 
        networkModems: action.payload.data.result, 
        totalCount: action.payload.data.totalCount > -1 ? action.payload.data.totalCount : state.totalCount,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_NETWORK_MODEMS_FAIL:
      return { 
        ...state, 
        networkModems: [],
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_NETWORK_MODEM_BY_ID_SUCCESS:
      return { 
        ...state, 
        currentNetworkModem: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_NETWORK_MODEM_BY_ID_FAIL:
      return { 
        ...state, 
        currentNetworkModem: null,
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_NETWORK_MODEM_SUCCESS:
      return { 
        ...state, 
        networkModems: [action.payload.data, ...state.networkModems],
        totalCount: state.totalCount + 1,
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_NETWORK_MODEM_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_NETWORK_MODEM_SUCCESS:
      return { 
        ...state, 
        networkModems: state.networkModems.map(modem => 
          modem._id === action.payload.data._id ? action.payload.data : modem
        ),
        currentNetworkModem: state.currentNetworkModem && state.currentNetworkModem._id === action.payload.data._id 
          ? action.payload.data 
          : state.currentNetworkModem,
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_NETWORK_MODEM_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_NETWORK_MODEM_SUCCESS:
      return { 
        ...state, 
        networkModems: state.networkModems.filter(modem => modem._id !== action.payload.id),
        totalCount: Math.max(0, state.totalCount - 1),
        currentNetworkModem: state.currentNetworkModem && state.currentNetworkModem._id === action.payload.id 
          ? null 
          : state.currentNetworkModem,
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_NETWORK_MODEM_FAIL:
      return { 
        ...state, 
        loading: false
      };
      
    default:
      return state;
  }
};
